import React, { useState, useEffect } from 'react';
import Table from 'view/component/Table';
import Card from 'view/component/Card';
import DatePicker from 'react-datepicker';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import apiService from 'apiService';
import { InlineLoading } from 'view/component/Loading';
import imageCompression from 'browser-image-compression';
import { showLoading, toast } from 'view/component/Alert';

const toBase64 = async (file) => {
  if (await file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
};

const UploadFile = ({
  data,
  idPendaftaran,
  handleUpload,
  url,
  paramMapper = () => { },
  tes = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [error, setError] = useState('');
  const [filex, setFilex] = useState('');

  function validate(file, maxSize, extension) {
    let thisError;
    const extensions = extension.split(',').map((validate) => validate);
    const arrFileName = file.name.split('.');
    const fileExtension = arrFileName[arrFileName.length - 1].toLowerCase();

    if (!extensions.includes(fileExtension)) {
      thisError = `extensi file harus ${extension}`;
      setError(thisError);
      return false;
    } else if (file.size > maxSize) {
      thisError = `ukuran file melebihi ${maxSize / 1024} KB`;
      setError(thisError);
      return false;
    } else {
      setError('');
      return true;
    }
  }

  const handleChange = async (e, data) => {
    if (e.target.files[0]) {
      showLoading('Sedang Mengupload')
      const options = {
        maxSizeMB: 1,          // (default: Number.POSITIVE_INFINITY)
        maxWidthOrHeight: 1024,   // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
        onProgress: Function,       // optional, a function takes one progress argument (percentage from 0 to 100) 
        useWebWorker: true,      // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
        // following options are for advanced users
        // maxIteration: number,       // optional, max number of iteration to compress the image (default: 10)
        // exifOrientation: number,    // optional, see https://stackoverflow.com/a/32490603/10395024
        // fileType: string,           // optional, fileType override
        // initialQuality: number      // optional, initial quality value between 0 and 1 (default: 1)
      }

      let file = e.target.files[0];
      const arrFileName = file?.name.split('.');
      const fileExtension = arrFileName[arrFileName.length - 1].toLowerCase();
      if (fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
        file = await imageCompression(file, options);
      }

      if (!validate(file, data.max_size, data.extension)) return toast({ status: 'error', text: 'gagal diunggah' });
      setIsLoading(true);
      const fileBase64 = await toBase64(file);
      let post = [
        {
          ref_persyaratan_id: data.id,
          trx_pend_perusahaan_id: idPendaftaran,
          upload: fileBase64,
        },
      ];

      if (paramMapper) {
        post = paramMapper(data, fileBase64);
      }

      const result = tes
        ? await setTimeout(() => true, 1000)
        : await apiService.post(url, post);
      if (result) {
        // console.log(result)
        setFilex(result.data.upload)
        handleUpload(data.id);
        setIsLoading(false);
        setIsCompleted(true);
        toast({ status: 'success', text: 'berhasil diunggah' })
      }
    }
  };
  const Example = ({ data }) => <div className="container"><iframe className="responsive-iframe" src={data}></iframe></div>
  return (
    <>
      <label>
        <span>upload file</span>
        <span className="text-success pl-2">
          {isCompleted && <i className="fas fa-check-circle fa-1x" />}
        </span>
      </label>
      <br />
      <input type="file" onChange={(e) => handleChange(e, data)} />
      <Example data={filex} />
      <br />
      {isLoading ? (
        <InlineLoading isLoading={isLoading} />
      ) : error ? (
        <span className="text-danger">{error}</span>
      ) : (
            ''
          )}
    </>
  );
};

const View = ({
  data,
  handleSubmit,
  setTanggalKunjungan = '',
  paramMapper = null,
  idPendaftaran,
  tes = false,
  url = '/department/persyaratan/upload',
}) => {
  const [isUploaded, setIsUploaded] = useState('');
  const [isCompleted, setIsCompleted] = useState(false);
  const [renderTime, setRenderTime] = useState(0);
  const [dis, setDis] = useState(true)
  const openFile = (url) => {
    const win = window.open(url, '_blank');
    if (!win) {
      win.focus();
    }
  };

  const handleUpload = (index) => {
    setIsUploaded((prevState) => ({ ...prevState, [index]: true }));
  };

  useEffect(() => {
    if (isUploaded) {
      const uploadTrueLength = Object.values(isUploaded).filter(
        (value) => value
      ).length;
      if (uploadTrueLength === Object.keys(isUploaded).length)
        setIsCompleted(true);
    }
  }, [isUploaded]);

  useEffect(() => {
    if (renderTime > 0) {
      if (isCompleted || tes) setDis(false);
    }
    setRenderTime(1);
  }, [isCompleted]);

  useEffect(() => {
    data.forEach((d) =>
      setIsUploaded((prevState) => ({ ...prevState, [d.id]: false }))
    );
  }, [data]);


  return (
    <>
      <h2 className="mb-2">Persyaratan</h2>
      <Table
        pagination={false}
        headers={['No', 'Nama', '']}
        data={data}
        columnMapper={(value, i) => {
          // console.log(value);
          return [
            <>
              <span
                style={{
                  // width: '300px',
                  whiteSpace: 'initial',
                  overflow: 'hidden',
                }}
              >
                {value.name || value.detail.name}
              </span>
              <br />
              <span className="text-danger">
                <small>{`ekstensi : ${value.extension}`}</small>
              </span>
              <br />
              <span className="text-danger">
                <small>{`ukuran maksimal : ${
                  value.max_size / 1000000
                  } MB`}</small>
              </span>
            </>,
            <UploadFile
              data={value}
              idPendaftaran={idPendaftaran}
              handleUpload={handleUpload}
              url={url}
              paramMapper={paramMapper}
              tes={tes}
            />,
          ];
        }}
      />
      <div>
        <div className="custom-control custom-checkbox mb-3 text-center">
          <input className="custom-control-input" id="customCheck2" type="checkbox" disabled={dis} onChange={handleSubmit} />
          <label className="custom-control-label " htmlFor="customCheck2"> <h4 className="text-success">saya menyatakan bahwa data dan dokumen yang saya upload
          sesuai dengan yang sebenarnya </h4>
          </label>
        </div>
      </div>
    </>
  );
};

export default View;
